export default __webpack_public_path__ + "static/media/oversight4.8d190b21.png";